import "./professionalBio.css";

const NicoleBioContent = (
  <div className="info-box-style">
    <p>
      On my path as a therapist and healer, one mantra has stayed close to my
      heart: You are the expert of your life. This simple truth guides everything I
      do—because I believe your story, your voice, and your wisdom matter
      deeply. My role is to walk alongside you as you reconnect with your agency,
      align with your truest self, and explore what healing looks like on your own
      terms.
      <br />
      <br />
      Rooted in mindfulness and intention, I aim to co-create a space that feels
      grounding, expansive, and real—where you can challenge old patterns, grow
      into your values, and care for the version of you that is learning to thrive. As
      a Person of the Global Majority living with ADHD, anxiety, and trauma, I know
      how exhausting it can be to move through a world that was not built to hold
      all of who you are.
      <br />
      <br />
      I show up to this work with deep respect for your lived experience, while
      gently naming the systemic and cultural forces that shape our lives. I
      approach therapy through a decolonial, neurodivergent-affirming lens—
      supporting you in moving toward radical self-acceptance, embodied healing,
      and sustainable care.
      <br />
      <br />
      A little about me: I am a 1.5-generation, neuroqueer, Afro-Latina therapist
      passionate about authentic, communal and holistic healing for QTBIPOC and
      immigrant adults.
      <br />
      <br />
      While I completed a Master of Education in Counselor Education with a
      concentration in Clinical Mental Health Counseling, I am wholly committed to
      a decolonial and liberatory-focused approach to therapy and an active
      dismantling of the oppressive systems that typically exclude bodies of
      culture and People of the Global Majority.
      <br />
      <br />
      I work alongside adults struggling with trauma, anxiety, grief, and stress,
      including racial stress/trauma and intergenerational trauma. My passion is
      helping those that identify as QTBIPOC, first/second generation, or
      neurodivergent adults. I mainly use a collaborative, person-centered,
      strengths-based and parts-work informed approach, while connecting the
      body/mind with somatic and mindfulness practices.
      <br />
      <br />
      I am grateful to offer an inclusive sliding scale fee, as I am passionate about
      enhancing accessibility for all to experience radical and holistic healing. I
      believe everyone deserves freedom from the daily stresses of surviving in a
      capitalist-oriented society, even if just for 50 minutes.
      <br />
      <br />
      I consider our time working together as a partnership in healing. I meet you
      where you are in a brave and supportive space to embrace, express, and
      connect with yourself.
    </p>
  </div>
);

export default NicoleBioContent;
